module.exports = __webpack_public_path__ + "static/media/view_selection_1.daf2a51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WxGraphTool/view_selection_1.png
// module id = 1770
// module chunks = 0